export const API_ENDPOINTS = {
  auth: {
    login: "/auth/login",
  },
  dashboard: {
    adminSummary: "/dashboard/admin/summary",
    adminMarketsRevenue: "/dashboard/admin/markets-revenue",
  },
  markets: {
    list: "/markets",
    detail: (id: number | string) => `/markets/${id}`,
    create: "/markets",
    update: (id: number | string) => `/markets/${id}`,
    delete: (id: number | string) => `/markets/${id}`,
  },
  categories: {
    list: "/categories",
    create: "/categories",
    update: (id: number | string) => `/categories/${id}`,
    delete: (id: number | string) => `/categories/${id}`,
  },
  upload: {
    image: "/upload/image",
  },
  stores: {
    listByApprovalStatus: (status: string) =>
      `/stores?approval_status=${encodeURIComponent(status)}`,
    byMarket: (marketId: number | string, approvalStatus = "approved") =>
      `/stores/by-market/${marketId}?approval_status=${encodeURIComponent(
        approvalStatus
      )}`,
    approve: (id: number | string) => `/stores/${id}/approve`,
    decline: (id: number | string) => `/stores/${id}/decline`,
    detail: (id: number | string) => `/stores/${id}`,
  },
  kyc: {
    byUser: (userId: number | string) => `/kyc/user/${userId}`,
  },
  vendors: {
    list: "/users/vendors",
  },
  packages: {
    list: "/packages",
    create: "/packages",
    update: (id: number | string) => `/packages/${id}`,
    delete: (id: number | string) => `/packages/${id}`,
  },
  masterProducts: {
    list: "/master-products",
    create: "/master-products",
    update: (id: number | string) => `/master-products/${id}`,
    delete: (id: number | string) => `/master-products/${id}`,
  },
  reps: {
    list: "/users/reps",
    create: "/users/reps",
    update: (id: number | string) => `/users/reps/${id}`,
    delete: (id: number | string) => `/users/reps/${id}`,
  },
};
